import { gql } from 'urql';

export const LINEA_FIELDS = gql`
  fragment LineaFields on Linea {
    id
    sucursal_id
    localidad_id
    codigo
    nombre
    descripcion
    limite_kilos
    limite_bultos
    limite_valor_declarado
    limite_m3
    limite_rc
    activa
    created_at
    updated_at
  }
`;

export const LINEAS_QUERY = gql`
  ${LINEA_FIELDS}
  query Lineas($sucursalId: Int!) {
    lineas(sucursalId: $sucursalId) {
      ...LineaFields
    }
  }
`;

export const LINEA_QUERY = gql`
  ${LINEA_FIELDS}
  query Linea($id: Int!, $sucursalId: Int!) {
    linea(id: $id, sucursalId: $sucursalId) {
      ...LineaFields
    }
  }
`;

export const CREAR_LINEA_MUTATION = gql`
  ${LINEA_FIELDS}
  mutation CrearLinea($input: LineaInput!) {
    crearLinea(input: $input) {
      ...LineaFields
    }
  }
`;

export const ACTUALIZAR_LINEA_MUTATION = gql`
  ${LINEA_FIELDS}
  mutation ActualizarLinea($id: Int!, $input: LineaInput!) {
    actualizarLinea(id: $id, input: $input) {
      ...LineaFields
    }
  }
`;

export const SET_LINEA_ACTIVA_MUTATION = gql`
  ${LINEA_FIELDS}
  mutation SetLineaActiva($id: Int!, $sucursalId: Int!, $activa: Boolean!) {
    setLineaActiva(id: $id, sucursalId: $sucursalId, activa: $activa) {
      ...LineaFields
    }
  }
`;

export const ELIMINAR_LINEA_MUTATION = gql`
  mutation EliminarLinea($id: Int!, $sucursalId: Int!) {
    eliminarLinea(id: $id, sucursalId: $sucursalId)
  }
`;


export const LINEA_MONITOR_QUERY = gql`
  query LineaMonitor($lineaId: Int!, $sucursalId: Int!) {
    lineaMonitor(lineaId: $lineaId, sucursalId: $sucursalId) {
      linea {
        id
        codigo
        nombre
        descripcion
        limite_kilos
        limite_bultos
        limite_valor_declarado
        limite_m3
        limite_rc
      }
      acumulados {
        valorDeclarado
        rc
        kilos
        mt3
        flete
        envios
      }
      maximos {
        valorDeclaradoMax
        rcMax
        kilosMax
        mt3Max
        fleteMax
        enviosMax
      }
    }
  }
`;
